<template>
    <div class="profile-container">
      <el-header>
        <div class="header-content">
          <el-button 
            icon="el-icon-back" 
            @click="goBack" 
            class="back-button"
          >
            Back
          </el-button>
          <h1>Edit Profile</h1>
        </div>
      </el-header>
      <el-main>
        <el-card class="profile-card">
          <el-tabs v-model="activeTab" type="card">
            <!-- Profile Tab -->
            <el-tab-pane label="Profile" name="profile">
          <div class="avatar-section">
            <el-upload
              class="avatar-uploader"
              action="#"
              :auto-upload="true"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :http-request="handleCustomUpload"
            >
              <div class="avatar-wrapper">
                <el-avatar 
                  :size="100" 
                  :src="profileForm.user_avatar_address_small"
                  class="avatar"
                  :style="{
                    border: getBorderStyleByUserType(profileForm.user_type),
                    backgroundColor: profileForm.user_avatar_address_small && profileForm.user_avatar_address_small !== '' && profileForm.user_avatar_address_small !== 'undefined' ? 'white' : '#e0e0e0',
                    color: getBorderStyleByUserType(profileForm.user_type).replace('2px solid', ''),
                    fontSize: '40px'
                  }"
                >
                  {{ profileForm.user_avatar_address_small && profileForm.user_avatar_address_small !== '' && profileForm.user_avatar_address_small !== 'undefined' ? '' : profileForm.user_nickName?.charAt(0) }}
                </el-avatar>
                <div class="avatar-mask">
                  <i class="el-icon-camera"></i>
                  <span>Change Avatar</span>
                </div>
              </div>
            </el-upload>
          </div>
  
          <div class="profile-form">
            <el-form 
              ref="profileForm"
              :model="profileForm"
              label-width="120px"
            >
              <el-form-item label="User Name" prop="user_nickName">
                <el-input
                  v-model="profileForm.user_nickName"
                  placeholder="Enter your nickname"
                ></el-input>
              </el-form-item>
  
              <el-form-item label="Email">
                <el-input
                  v-model="profileForm.user_email"
                  disabled
                  placeholder="Your email address"
                ></el-input>
              </el-form-item>

              <el-form-item label="Knowit Account ID">
                <div v-if="profileForm.knowit_account_id">
                  <el-input
                    v-model="profileForm.knowit_account_id"
                    disabled
                    placeholder="Your Knowit Account ID"
                  ></el-input>
                  <div class="field-note">
                    <i class="el-icon-info"></i>
                    This ID is unique and cannot be changed once set.
                  </div>
                </div>
                <div v-else>
                  <el-button 
                    type="primary" 
                    @click="showKnowitIdDialog"
                    icon="el-icon-edit"
                  >
                    Setup my unique Knowit ID
                  </el-button>
                  <div class="field-note">
                    <i class="el-icon-info"></i>
                    Create a unique identifier for your account (0-9, a-Z, _ only).
                  </div>
                </div>
              </el-form-item>
  
              <el-form-item label="Signature" prop="user_signature">
                <el-input
                  type="textarea"
                  v-model="profileForm.user_signature"
                  :rows="2"
                  placeholder="Your signature line..."
                ></el-input>
              </el-form-item>
  
              <el-form-item label="Introduction" prop="user_intro">
                <el-input
                  type="textarea"
                  v-model="profileForm.user_intro"
                  :rows="4"
                  placeholder="Write something about yourself..."
                ></el-input>
              </el-form-item>

              <el-form-item label="User Type" prop="user_type">
                <el-select v-model="profileForm.user_type" placeholder="Select user type">
                  <el-option label="Individual" value="individual"></el-option>
                  <el-option label="Institution" value="institution"></el-option>
                  <!-- <el-option label="AI Agent" value="agent"></el-option> -->
                </el-select>
              </el-form-item>
  
              <!-- <el-form-item label="Creator Level" prop="creator_functionality_level">
                <el-select v-model="profileForm.creator_functionality_level" placeholder="Select creator level" disabled>
                  <el-option label="Basic" value="Basic"></el-option>
                  <el-option label="Pro" value="Pro"></el-option>
                </el-select>
              </el-form-item> -->

              <el-form-item>
                <el-button
                  type="primary"
                  @click="saveProfile"
                  :loading="saving"
                  style="width: 120px; display: flex; justify-content: center; align-items: center"
                >
                  Save Changes
                </el-button>
              </el-form-item>
            </el-form>
          </div>
            </el-tab-pane>

            <!-- Personal Master File Tab (hidden) -->
            <el-tab-pane v-if="false" label="Personal Master File" name="pmf">
              <div class="pmf-container">
                <div class="pmf-header">
                  <h3>Personal Master File</h3>
                  <el-button
                    v-if="!pmfEditMode"
                    type="primary"
                    size="small"
                    @click="enterPMFEditMode"
                    icon="el-icon-edit"
                  >
                    Edit Mode
                  </el-button>
                  <div v-else class="pmf-actions">
                    <el-button
                      size="small"
                      @click="cancelPMFEdit"
                    >
                      Cancel
                    </el-button>
                    <el-button
                      type="primary"
                      size="small"
                      @click="savePMF"
                      :loading="savingPMF"
                      icon="el-icon-check"
                    >
                      Save
                    </el-button>
                  </div>
                </div>

                <div class="field-note pmf-note">
                  <i class="el-icon-info"></i>
                  This is your personal space to store any information, files references, preferences, or notes.
                </div>

                <!-- Edit Mode -->
                <div v-if="pmfEditMode" class="pmf-editor">
                  <el-input
                    type="textarea"
                    v-model="pmfContent"
                    :rows="20"
                    placeholder="Enter your master file, objectives, priorities, preferences, notes, and other information here (Markdown supported)..."
                  ></el-input>
                </div>

                <!-- View Mode (Markdown Rendered) -->
                <div v-else class="pmf-viewer">
                  <div v-if="profileForm.user_PMF && profileForm.user_PMF.trim()"
                       class="pmf-content"
                       v-html="renderMarkdown(profileForm.user_PMF)">
                  </div>
                  <div v-else class="pmf-empty">
                    <i class="el-icon-document"></i>
                    <p>No Personal Master File yet. Click "Edit Mode" to create one.</p>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-main>

      <!-- Knowit Account ID Setup Dialog -->
      <el-dialog
        title="Setup Your Unique Knowit Account ID"
        :visible.sync="knowitIdDialogVisible"
        width="70%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <div class="dialog-content">
          <div class="alert-message">
            <i class="el-icon-warning"></i>
            <strong>Important:</strong> This ID is unique and cannot be changed once set. 
            Only use characters: 0-9, a-Z, and underscore (_).
          </div>
          
          <el-form :model="knowitIdForm" :rules="knowitIdRules" ref="knowitIdForm" label-width="0">
            <el-form-item prop="knowit_account_id">
              <el-input
                v-model="knowitIdForm.knowit_account_id"
                placeholder="Enter your unique Knowit Account ID"
                maxlength="30"
                show-word-limit
                @input="validateKnowitId"
              >
                <template slot="prepend">@</template>
              </el-input>
            </el-form-item>
          </el-form>
          
          <div class="validation-message" v-if="validationMessage">
            <i :class="validationIcon"></i>
            {{ validationMessage }}
          </div>
        </div>
        
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelKnowitIdSetup">Cancel</el-button>
          <el-button 
            type="primary" 
            @click="saveKnowitId"
            :loading="savingKnowitId"
            :disabled="!isKnowitIdValid"
          >
            Save Knowit ID
          </el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { postRequest } from '@/apis/front'
  import Post from '@/components/Post'
  import * as qiniu from 'qiniu-js'
  import Cookies from 'js-cookie'
  import { marked } from 'marked'
  import DOMPurify from 'dompurify'
  
  export default {
    name: 'Personal',
    components: {
      Post
    },
    data() {
      return {
        activeTab: 'profile',
        profileForm: {
          user_nickName: '',
          user_signature: '',
          user_intro: '',
          user_PMF: '',
          user_avatar_address_small: '',
          user_avatar_address_big: '',
          user_type: '',
          user_email: '',
          creator_functionality_level: 'Basic',
          knowit_account_id: ''
        },
        saving: false,
        originalData: {},
        knowitIdDialogVisible: false,
        knowitIdForm: {
          knowit_account_id: ''
        },
        knowitIdRules: {
          knowit_account_id: [
            { required: true, message: 'Please enter your Knowit Account ID', trigger: 'blur' },
            { min: 3, max: 30, message: 'Length should be 3 to 30 characters', trigger: 'blur' },
            { pattern: /^[0-9a-zA-Z_]+$/, message: 'Only 0-9, a-Z, and underscore (_) are allowed', trigger: 'blur' }
          ]
        },
        savingKnowitId: false,
        validationMessage: '',
        validationIcon: '',
        pmfEditMode: false,
        pmfContent: '',
        savingPMF: false
      }
    },
    computed: {
      isKnowitIdValid() {
        const value = this.knowitIdForm.knowit_account_id;
        return value && /^[0-9a-zA-Z_]{3,30}$/.test(value);
      }
    },
    created() {
      this.fetchProfileData()
      this.initializeUserTypeFromCookies()
    },
    methods: {
      renderMarkdown(content) {
        if (!content) return ''

        marked.setOptions({
          breaks: true,
          gfm: true,
          headerIds: false,
          mangle: false
        })

        const rawHtml = marked(content)
        return DOMPurify.sanitize(rawHtml, {
          ADD_TAGS: ['mark'],
          ADD_ATTR: ['target', 'rel']
        })
      },
      enterPMFEditMode() {
        this.pmfContent = this.profileForm.user_PMF || ''
        this.pmfEditMode = true
      },
      cancelPMFEdit() {
        this.pmfEditMode = false
        this.pmfContent = ''
      },
      async savePMF() {
        try {
          this.savingPMF = true

          const response = await postRequest('updateUserProfile', {
            user_id: this.$store.state.user_id,
            user_nickName: this.profileForm.user_nickName,
            user_signature: this.profileForm.user_signature,
            user_intro: this.profileForm.user_intro,
            user_type: this.profileForm.user_type,
            user_PMF: this.pmfContent
          })

          if (response.data.code === 0) {
            this.$message.success('Personal Master File saved successfully')
            this.profileForm.user_PMF = this.pmfContent
            this.pmfEditMode = false
          } else {
            throw new Error(response.data.msg || 'Failed to save')
          }
        } catch (error) {
          this.$message.error(error.message || 'Failed to save Personal Master File')
        } finally {
          this.savingPMF = false
        }
      },
      initializeUserTypeFromCookies() {
        // Check if user_type exists in cookies but not in store
        const cookieUserType = Cookies.get('user_type')
        const storeUserType = this.$store.state.user_info?.user_type
        
        console.log('Initializing user_type:')
        console.log('- Cookie user_type:', cookieUserType)
        console.log('- Store user_type:', storeUserType)
        
        if (cookieUserType && !storeUserType) {
          // Initialize store with user_type from cookies
          this.$store.commit('setUserType', cookieUserType)
          console.log('Initialized user_type from cookies:', cookieUserType)
        }
      },
      async fetchProfileData() {
        try {
          const response = await postRequest('getUserProfile', {
            user_id: this.$store.state.user_id
          })
          
          if (response.data.code === 0) {
            const newCreatorLevel = response.data.data.creator_functionality_level || 'Basic'
            const currentCreatorLevel = this.$store.state.creator_functionality_level || 'Basic'
            
            this.profileForm = {
              user_nickName: response.data.data.user_nickName || '',
              user_signature: response.data.data.user_signature || '',
              user_intro: response.data.data.user_intro || '',
              user_PMF: response.data.data.user_PMF || '',
              user_avatar_address_small: response.data.data.user_avatar_address_small || '',
              user_avatar_address_big: response.data.data.user_avatar_address_big || '',
              user_type: response.data.data.user_type || 'individual',
              user_email: response.data.data.user_email || '',
              creator_functionality_level: newCreatorLevel,
              knowit_account_id: response.data.data.knowit_account_id || ''
            }
            this.originalData = { ...this.profileForm }
            
            // Update store if creator functionality level has changed
            if (newCreatorLevel !== currentCreatorLevel) {
              this.$store.commit('setUserCreatorLevel', {
                creator_functionality_level: newCreatorLevel,
              })
            }
            
          } else {
            this.$message.error(response.data.msg || 'Failed to load profile')
          }
        } catch (error) {
          console.error('Error loading profile:', error)
          this.$message.error('Failed to load profile')
        }
      },
      async saveProfile() {
        if (JSON.stringify(this.profileForm) === JSON.stringify(this.originalData)) {
          this.$message.info('No changes to save')
          return
        }
  
        this.saving = true
        try {
          const response = await postRequest('updateUserProfile', {
            user_id: this.$store.state.user_id,
            user_nickName: this.profileForm.user_nickName,
            user_signature: this.profileForm.user_signature,
            user_intro: this.profileForm.user_intro,
            user_PMF: this.profileForm.user_PMF,
            user_type: this.profileForm.user_type
          })
          
          if (response.data.code === 0) {
            this.$message.success('Profile updated successfully')
            
            // Update store with all profile changes using the updateUserProfile mutation
            this.$store.commit('updateUserProfile', {
              user_name: this.profileForm.user_nickName,
              user_avatar_address_small: this.profileForm.user_avatar_address_small,
              user_type: this.profileForm.user_type
            })
            
            // Update originalData after successful save
            this.originalData = { ...this.profileForm }
            
          } else {
            throw new Error(response.data.msg || 'Update failed')
          }
        } catch (error) {
          this.$message.error(error.message || 'Failed to update profile')
          this.profileForm = { ...this.originalData }
        } finally {
          this.saving = false
        }
      },
      async handleCustomUpload({ file }) {
        console.log('handleCustomUpload called with file:', file); // Debug log

        try {
          const tokenResponse = await postRequest("getSingaporeQiniuToken", {});
          if (!tokenResponse.data || !tokenResponse.data.data) {
            throw new Error('Failed to get upload token');
          }
          const token = tokenResponse.data.data;

          // Show preview immediately
          const reader = new FileReader();
          reader.onload = (e) => {
            this.profileForm.user_avatar_address_small = e.target.result;
          };
          reader.readAsDataURL(file);

          // Upload to Qiniu
          const observable = qiniu.upload(
            file,
            `${new Date().getTime()}_${file.name}`,
            token
          );

          observable.subscribe({
            next: (res) => {
              console.log('Upload progress:', res.total.percent); // Debug log
            },
            error: (err) => {
              console.error("Upload error:", err);
              this.$message.error("Failed to upload avatar");
              this.profileForm.user_avatar_address_small = this.originalData.user_avatar_address_small || "";
            },
            complete: async (res) => {
              console.log('Upload complete:', res); // Debug log
              const key = res.key;
              await this.updateUserAvatar(key);
            }
          });
        } catch (error) {
          console.error("Error in handleCustomUpload:", error);
          this.$message.error("Failed to upload avatar");
        }
      },
      async beforeAvatarUpload(file) {
        console.log('beforeAvatarUpload called with file:', file); // Debug log
        
        const isImage = file.type.startsWith('image/')
        const isLt2M = file.size / 1024 / 1024 < 2
  
        if (!isImage) {
          this.$message.error('Avatar must be an image file!')
          return false
        }
        if (!isLt2M) {
          this.$message.error('Avatar size can not exceed 2MB!')
          return false
        }

        return true; // Changed to return true to allow upload to proceed
      },
      async updateUserAvatar(key) {
        try {
          const response = await postRequest('uploadUserAvatar', {
            user_id: this.$store.state.user_id,
            user_avatar_key: key,
            size: 'small'
          });
          
          if (response.data.code === 0) {
            // Update local state
            this.profileForm.user_avatar_address_small = response.data.data.user_avatar_address_small;
            this.profileForm.user_avatar_address_big = response.data.data.user_avatar_address_big || response.data.data.user_avatar_address_small;
            
            // Update Vuex store and multiAccountManager through the store mutation
            this.$store.commit('setUserAvatar', response.data.data.user_avatar_address_small);
            
            // Update originalData to reflect the new avatar
            this.originalData.user_avatar_address_small = response.data.data.user_avatar_address_small;
            this.originalData.user_avatar_address_big = this.profileForm.user_avatar_address_big;
            
            this.$message.success('Avatar updated successfully');
          } else {
            throw new Error(response.data.msg || 'Failed to update avatar');
          }
        } catch (error) {
          this.$message.error(error.message || 'Failed to update avatar');
          this.profileForm.user_avatar_address_small = ''; // Clear preview on error
        }
      },
      getBorderStyleByUserType(userType) {
        // Default to Individual if not set
        const type = userType || 'individual';
        
        switch(type) {
          case 'individual':
            return '2px solid #1890ff'; // Theme blue border
          case 'institution':
            return '2px solid #67C23A'; // Green border for institutions
          case 'agent':
            return '2px solid #E6A23C'; // Orange border for agents
          default:
            return '1px solid #e0e0e0'; // Default gray border
        }
      },
      goBack() {
        this.$router.go(-1)
      },
      showKnowitIdDialog() {
        this.knowitIdDialogVisible = true;
        this.knowitIdForm.knowit_account_id = '';
        this.validationMessage = '';
        this.validationIcon = '';
      },
      validateKnowitId() {
        const value = this.knowitIdForm.knowit_account_id;
        
        if (!value) {
          this.validationMessage = 'Knowit Account ID is required.';
          this.validationIcon = 'el-icon-warning';
          return;
        }
        
        if (!/^[0-9a-zA-Z_]+$/.test(value)) {
          this.validationMessage = 'Only 0-9, a-Z, and underscore (_) are allowed.';
          this.validationIcon = 'el-icon-error';
          return;
        }
        
        if (value.length < 3) {
          this.validationMessage = 'Knowit Account ID must be at least 3 characters long.';
          this.validationIcon = 'el-icon-warning';
          return;
        }
        
        if (value.length > 30) {
          this.validationMessage = 'Knowit Account ID cannot exceed 30 characters.';
          this.validationIcon = 'el-icon-error';
          return;
        }
        
        this.validationMessage = 'Valid Knowit Account ID format.';
        this.validationIcon = 'el-icon-success';
      },
      cancelKnowitIdSetup() {
        this.knowitIdDialogVisible = false;
        this.knowitIdForm.knowit_account_id = '';
        this.validationMessage = '';
        this.validationIcon = '';
      },
      async saveKnowitId() {
        this.savingKnowitId = true;
        try {
          const response = await postRequest('updateUserKnowitAccountId', {
            user_id: this.$store.state.user_id,
            knowit_account_id: this.knowitIdForm.knowit_account_id
          });

          if (response.data.code === 0) {
            this.$message.success('Knowit Account ID saved successfully');
            this.profileForm.knowit_account_id = this.knowitIdForm.knowit_account_id;
            this.cancelKnowitIdSetup();
          } else {
            throw new Error(response.data.msg || 'Failed to save Knowit Account ID');
          }
        } catch (error) {
          this.$message.error(error.message || 'Failed to save Knowit Account ID');
        } finally {
          this.savingKnowitId = false;
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .profile-container {
    width: 100%;
  }
  
  .header-content {
    display: flex;
    align-items: center;
    position: relative;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    height: 100%;
  }
  
  .el-header {
    background-color: #409EFF;
    color: white;
    text-align: center;
    padding: 0;
    height: 60px;
  }
  
  .back-button {
    position: absolute;
    left: 20px;
    color: white;
    border: 1px solid white;
    background: transparent;
    z-index: 1;
  }
  
  .back-button:hover {
    background: rgba(255, 255, 255, 0.1);
    color: white;
    border-color: white;
  }
  
  .profile-card {
    width: 90%;
    max-width: 1200px;
    margin: 20px auto;
    padding: 30px;
  }
  
  .avatar-section {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
  }
  
  .avatar-wrapper {
    position: relative;
    cursor: pointer;
    border-radius: 50%;
    overflow: hidden;
    border: 1px solid #dcdfe6;
  }
  .avatar {
    display: block;
    background: white;
  }
  
  .avatar-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    opacity: 0;
    transition: opacity 0.3s;
  }
  
  .avatar-wrapper:hover .avatar-mask {
    opacity: 1;
  }
  
  .avatar-mask i {
    font-size: 24px;
    margin-bottom: 5px;
  }
  
  .avatar-mask span {
    font-size: 12px;
  }
  
  .profile-form {
    max-width: 800px;
    margin: 0 auto;
  }
  
  .save-button-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
  
  h1 {
    flex: 1;
    text-align: center;
    margin: 0;
    font-size: 20px;
  }

  .field-note {
    margin-top: 8px;
    font-size: 12px;
    color: #909399;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .field-note i {
    font-size: 14px;
  }

  .dialog-content {
    padding: 20px 0;
  }

  .alert-message {
    background-color: #fdf6ec;
    border: 1px solid #f5dab1;
    border-radius: 4px;
    padding: 12px;
    margin-bottom: 20px;
    color: #e6a23c;
    font-size: 14px;
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }

  .alert-message i {
    margin-top: 2px;
    font-size: 16px;
  }

  .validation-message {
    margin-top: 8px;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .validation-message i {
    font-size: 14px;
  }

  .validation-message:has(.el-icon-success) {
    color: #67c23a;
  }

  .validation-message:has(.el-icon-warning) {
    color: #e6a23c;
  }

  .validation-message:has(.el-icon-error) {
    color: #f56c6c;
  }

  /* PMF Tab Styles */
  .pmf-container {
    padding: 20px;
  }

  .pmf-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .pmf-header h3 {
    margin: 0;
    font-size: 20px;
    color: #303133;
  }

  .pmf-actions {
    display: flex;
    gap: 10px;
  }

  .pmf-note {
    margin-bottom: 20px;
  }

  .pmf-editor {
    margin-top: 20px;
  }

  .pmf-editor .el-textarea__inner {
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: 14px;
    line-height: 1.6;
  }

  .pmf-viewer {
    margin-top: 20px;
    min-height: 400px;
  }

  .pmf-content {
    padding: 20px;
    background: #ffffff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    min-height: 400px;
    font-size: 14px;
    line-height: 1.8;
    color: #303133;
  }

  .pmf-content h1,
  .pmf-content h2,
  .pmf-content h3,
  .pmf-content h4,
  .pmf-content h5,
  .pmf-content h6 {
    margin-top: 20px;
    margin-bottom: 12px;
    font-weight: 600;
    line-height: 1.4;
  }

  .pmf-content h1 { font-size: 28px; }
  .pmf-content h2 { font-size: 24px; }
  .pmf-content h3 { font-size: 20px; }
  .pmf-content h4 { font-size: 18px; }
  .pmf-content h5 { font-size: 16px; }
  .pmf-content h6 { font-size: 14px; }

  .pmf-content p {
    margin: 12px 0;
  }

  .pmf-content ul,
  .pmf-content ol {
    margin: 12px 0;
    padding-left: 24px;
  }

  .pmf-content li {
    margin: 6px 0;
  }

  .pmf-content strong {
    font-weight: 600;
  }

  .pmf-content code {
    background: #f5f7fa;
    padding: 2px 6px;
    border-radius: 3px;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: 13px;
  }

  .pmf-content pre {
    background: #f5f7fa;
    padding: 12px;
    border-radius: 4px;
    overflow-x: auto;
    margin: 12px 0;
  }

  .pmf-content pre code {
    background: none;
    padding: 0;
  }

  .pmf-content blockquote {
    margin: 12px 0;
    padding: 8px 16px;
    border-left: 4px solid #409eff;
    background-color: #f5f7fa;
    color: #606266;
  }

  .pmf-content a {
    color: #409eff;
    text-decoration: none;
  }

  .pmf-content a:hover {
    text-decoration: underline;
  }

  .pmf-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    color: #909399;
    text-align: center;
  }

  .pmf-empty i {
    font-size: 64px;
    margin-bottom: 20px;
    opacity: 0.5;
  }

  .pmf-empty p {
    font-size: 16px;
    margin: 0;
  }
  </style> 